import type { SeedkitCore } from '@seedkit/core';
import { TokenStorage } from '@seedkit/vue-administration-module/public';
import {
  clearStashedRefreshToken,
  ensureValidSession,
  persistStashedRefreshToken,
  setSessionApiBaseUrl,
} from './session-lifecycle';

const CHECK_INTERVAL_MS = 30_000;

/**
 * Proactive session expiry handling (Seedkit `isTokenExpired` freezes `nowDate` on store init).
 */
export function bootstrapSessionExpiryWatchdog(seedkit: SeedkitCore): void {
  const httpBase = (seedkit as { http?: { baseUrl?: string } }).http?.baseUrl;
  if (httpBase) {
    setSessionApiBaseUrl(String(httpBase));
  }

  seedkit.eventBus.on('login', () => {
    persistStashedRefreshToken();
  });

  seedkit.eventBus.on('logout', () => {
    clearStashedRefreshToken();
  });

  const check = () => {
    if (!TokenStorage.getAccessToken()) {
      return;
    }
    void ensureValidSession();
  };

  check();
  setInterval(check, CHECK_INTERVAL_MS);

  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        check();
      }
    });
  }

  if (typeof window !== 'undefined') {
    window.addEventListener('focus', check);
  }
}
